export default "__VITE_ASSET__ef026008__"